import { Injectable } from '@angular/core';
import { HeaderInjector } from '../http/InjectionBundle';
import { TranslateService } from '@ngx-translate/core';
import { RestHeader } from '../http/RestResource';

@Injectable()
export class LocaleHeaderInjector implements HeaderInjector {
	constructor(private translateService: TranslateService) {}

	async getHeader(): Promise<RestHeader> {
		return { 'Accept-Language': `${this.translateService.currentLang}, en-US` };
	}
}
